import { getModuleInstance, wasmFuncs } from "./module.js";
let _reader = null;
export function getWasmReader() {
    if (_reader === null || _reader.buffer.byteLength === 0) {
        _reader = new DataView(getModuleInstance().exports.memory.buffer);
    }
    return _reader;
}
const decoder = new TextDecoder("utf-8");
export function getStringAt(ptr) {
    if (ptr === 0)
        return null;
    const bytes = [];
    while (true) {
        const byte = getWasmReader().getUint8(ptr);
        if (byte === 0)
            break;
        bytes.push(byte);
        ptr += 1;
    }
    return decoder.decode(new Uint8Array(bytes));
}
export const PTR_SIZE = 4;
export const U64_SIZE = 8;
export const I64_SIZE = 8;
export const U32_SIZE = 4;
export const I32_SIZE = 4;
export const U8_SIZE = 1;
export const I8_SIZE = 1;
export const BOOL_SIZE = 1;
export class Struct {
    static allocStruct(size) {
        const ptr = wasmFuncs.malloc(size);
        const struct = new this(ptr);
        struct.own();
        return struct;
    }
    _assert_live() {
        if (!this._live)
            throw new Error("Trying to access dead object");
    }
    own() {
        this._assert_live();
        if (this._owned)
            throw new Error("Trying to reown owned object");
        this._owned = true;
        const proto = Object.getPrototypeOf(this).constructor;
        Struct.finReg.register(this, [this._ptr, proto.unalloc], this);
    }
    static unalloc(ptr) { }
    free() {
        this._assert_live();
        if (!this._owned)
            throw new Error("Trying to free borrowed object");
        this._live = false;
        Struct.finReg.unregister(this);
        const proto = Object.getPrototypeOf(this).constructor;
        proto.unalloc?.(this._ptr);
        wasmFuncs.free(this._ptr);
    }
    constructor(ptr) {
        this._live = true;
        this._owned = false;
        this._ptr = ptr;
    }
    getBool(offset) {
        this._assert_live();
        return !!getWasmReader().getUint8(this._ptr + offset);
    }
    getU8(offset) {
        this._assert_live();
        return getWasmReader().getUint8(this._ptr + offset);
    }
    getI8(offset) {
        this._assert_live();
        return getWasmReader().getInt8(this._ptr + offset);
    }
    getU32(offset) {
        this._assert_live();
        return getWasmReader().getUint32(this._ptr + offset, true);
    }
    getU64(offset) {
        this._assert_live();
        return getWasmReader().getBigUint64(this._ptr + offset, true);
    }
    getPtr(offset) {
        this._assert_live();
        return this.getU32(offset);
    }
    getI32(offset) {
        this._assert_live();
        return getWasmReader().getInt32(this._ptr + offset, true);
    }
    setBool(offset, val) {
        this._assert_live();
        getWasmReader().setUint8(this._ptr + offset, val ? 1 : 0);
    }
    setU8(offset, val) {
        this._assert_live();
        getWasmReader().setUint8(this._ptr + offset, val);
    }
    setI8(offset, val) {
        this._assert_live();
        getWasmReader().setInt8(this._ptr + offset, val);
    }
    setU32(offset, val) {
        this._assert_live();
        getWasmReader().setUint32(this._ptr + offset, val, true);
    }
    setI32(offset, val) {
        this._assert_live();
        getWasmReader().setInt32(this._ptr + offset, val, true);
    }
}
Struct.finReg = new FinalizationRegistry(([ptr, unalloc]) => {
    unalloc(ptr);
    wasmFuncs.free(ptr);
});
Struct.size = 0;
export function makeAccessorClassObj(inst) {
    return new Proxy(inst, {
        get(target, p, receiver) {
            if (typeof p === "symbol")
                return Reflect.get(target, p, receiver);
            const pInt = parseInt(p);
            if (isNaN(pInt) || pInt < 0 || pInt >= target.length)
                return Reflect.get(target, p, receiver);
            return target.getItem(pInt);
        },
    });
}
export class CVector extends Struct {
    get length() {
        return wasmFuncs.Vector_any_get_length(this._ptr);
    }
    getItem(idx) {
        return this.instantiateItem(wasmFuncs.Vector_any_get_ptr(this._ptr, this.getItemSize(), idx));
    }
    constructor(_ptr) {
        super(_ptr);
        return makeAccessorClassObj(this);
    }
    *[Symbol.iterator]() {
        for (let idx = 0; idx < this.length; idx += 1) {
            yield this[idx];
        }
    }
}
//# sourceMappingURL=struct.js.map